/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import PostBraindateFeedbackSuccessNotificationDumb from './PostBraindateFeedbackSuccessNotificationDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (state: State, { notification }: Props): Object => ({
  // Only used in Merge props
  notification,
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(PostBraindateFeedbackSuccessNotificationDumb);
